/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmdk_No_Documents_MatchInputs */

const en_cmdk_no_documents_match = /** @type {(inputs: Cmdk_No_Documents_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No documents match your search.`)
};

const es_cmdk_no_documents_match = /** @type {(inputs: Cmdk_No_Documents_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ningún documento coincide con tu búsqueda.`)
};

/**
* | output |
* | --- |
* | "No documents match your search." |
*
* @param {Cmdk_No_Documents_MatchInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cmdk_no_documents_match = /** @type {((inputs?: Cmdk_No_Documents_MatchInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmdk_No_Documents_MatchInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_cmdk_no_documents_match(inputs)
	return en_cmdk_no_documents_match(inputs)
});